// src/store/slices/shareSlice.ts
/**
 * Share and loading state management
 * Implements Section 5.8 of the specification
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ShareState } from '../../types/redux';

const initialState: ShareState = {
  isLoading: false,
  loadedFromShare: false,
};

export const shareSlice = createSlice({
  name: 'share',
  initialState,
  reducers: {
    /**
     * Set loading state for share operations
     */
    setShareLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },

    /**
     * Set the last generated share code
     */
    setLastShareCode: (state, action: PayloadAction<string>) => {
      state.lastShareCode = action.payload;
    },

    /**
     * Set share URL for link sharing
     */
    setShareUrl: (state, action: PayloadAction<string>) => {
      state.shareUrl = action.payload;
    },

    /**
     * Mark that current state was loaded from a share
     */
    setLoadedFromShare: (state, action: PayloadAction<boolean>) => {
      state.loadedFromShare = action.payload;
    },

    /**
     * Clear share state
     */
    clearShareState: (state) => {
      state.lastShareCode = undefined;
      state.shareUrl = undefined;
      state.loadedFromShare = false;
      state.isLoading = false;
    },
  },
});

export const {
  setShareLoading,
  setLastShareCode,
  setShareUrl,
  setLoadedFromShare,
  clearShareState,
} = shareSlice.actions;

export default shareSlice.reducer;